export enum BatchedMeshType {
    Physical = 'physical',
    Sheet = 'sheet',
    Holes = 'holes'
}
